export default function (Component) {
Component.options.__tip = "<p><code>FdSelect</code> supports <code>v-model</code>.</p>\n"
}